document.addEventListener('DOMContentLoaded', () => {
	const params = new URLSearchParams(window.location.search)

	if (params.has('klaviyo_id') || params.has('_kx')) {

		fetch(`/mobler-api/session/relewise/TrackUserUpdate?${params.toString()}`)
	}
})

